import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Profiler } from '../webApi/DataModels'

class ProfileState {
public profileList: Profiler[] = []
}

const mutations = <MutationTree<ProfileState>>{
  setProfiler (state: ProfileState, profileList: Profiler[]) {
    state.profileList = profileList
    window.sessionStorage.setItem('Profiler_List', JSON.stringify(state.profileList))
  },
  reset (state:ProfileState) {
    state.profileList = []
  }
}

const actions = <ActionTree<ProfileState, any>>{
  reset (store: ActionContext<ProfileState, any>):void {
    store.commit('reset')
  },
  loadProfiler (store: ActionContext<ProfileState, any>, profileFilter: any):Promise<any> {
    // the list has not been stored in session yet, load from server
    return webApi.profile.get_Profile(profileFilter).then(
      (response) => {
        // Store the response
        store.commit('setProfiler', response.data)
        return Promise.resolve(response.data)
      }).catch((response) => {
      window.bus.$emit('openErrorModal', 'error loading profileList: ' + response.ExceptionMessage)
      return Promise.reject(response)
    })
  }
}

const getters = <GetterTree<ProfileState, any>>{
  profileList: (state) => {
    return state.profileList
  }
}
export default ({
  namespaced: true,
  state: new ProfileState(),
  mutations,
  actions,
  getters
})
